import { render, staticRenderFns } from "./codeQR.vue?vue&type=template&id=61374576&scoped=true&"
import script from "./codeQR.vue?vue&type=script&lang=js&"
export * from "./codeQR.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61374576",
  null
  
)

export default component.exports